import React from 'react';
import { Play } from '@benzinga/icons';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import { BzImage } from '@benzinga/image';

export interface MediaCardProps {
  id?: number;
  title: string;
  subtitle?: string | null;
  contentId?: string;
  image: string;
  link: string;
}

export const MediaCard: React.FC<MediaCardProps> = ({ contentId, image, link, subtitle, title }) => {
  const dataAction = contentId ? `${contentId} Media Card Click` : 'Media Card Click';
  return (
    <Container
      className="flex w-full justify-between rounded"
      data-action={dataAction}
      href={link}
      rel="noreferrer noopener"
      target="_blank"
    >
      <div className="flex flex-col min-h-[120px] p-4 rounded text-white">
        <TitleWrapper className="media-card-title">
          <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }} />
        </TitleWrapper>
        <ContentWrapper>
          <Subtitle
            className="media-card-subtitle"
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(subtitle ?? '') }}
          ></Subtitle>
        </ContentWrapper>
      </div>
      <WithBgImage>
        <div className="z-[2] absolute bottom-2 right-2">
          <PlayBtn>
            <Play />
          </PlayBtn>
        </div>
        <BzImage
          alt=""
          layout="fill"
          loaderProps={{ width: 200 }}
          src={image || '/next-assets/images/android-chrome-384x384.png'}
        />
      </WithBgImage>
    </Container>
  );
};

const Container = styled.a`
  background: ${({ theme }) => theme.colorPalette.neutral900};
`;

const WithBgImage = styled.div`
  position: relative;
  min-height: 120px;
  width: 120px;
  min-width: 120px;
  max-width: 120px;
`;

const TitleWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: bold;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Subtitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  margin-right: 16px;
  opacity: 0.6;
`;

const PlayBtn = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.brand};
  color: #fff;
  display: flex;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;
